import Hero from '@/components/Hero';
import About from '@/components/About';
import Services from '@/components/Services';
import Projects from '@/components/Projects';
import Partners from '@/components/Partners';
import Achievements from '@/components/Achievements';
import Testimonials from '@/components/Testimonials';
import Contact from '@/components/Contact';
import { usePageMeta } from '@/hooks/usePageMeta';

const Home = () => {
  usePageMeta({
    title: 'Next Leap Inc | Real Estate Mandates Across India',
    description: 'Mandate-led plotted developments and premium residential projects across India, led by Vikrant Pawar and Bhagwandas Kewat.',
  });

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <Hero />
      <About />
      <Services />
      <Projects />
      <Partners />
      <Achievements />
      <Testimonials />
      <Contact />
    </div>
  );
};

export default Home;
